import { render, staticRenderFns } from "./AppliancesExtends.vue?vue&type=template&id=4b8f2f9d&"
import script from "./AppliancesExtends.vue?vue&type=script&lang=js&"
export * from "./AppliancesExtends.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports